import { Component } from 'react';
class MapsDroneLayer extends Component {

    constructor(props) {
        super(props);
        this.imageMapType = null;
        this.redraw = this.redraw.bind(this);
    }

    componentWillUnmount() {

    }

    redraw() {
        const { droneLayer } = this.props;
        if ( window.mapRef === undefined || droneLayer === undefined || droneLayer === false || this.imageMapType !== null){
            return 
        } 
        if ( droneLayer === null && this.imageMapType !== null) {
            this.imageMapType.setMap(null)
            return
        }
        else if (droneLayer !== null ){
            this.imageMapType = new window.google.maps.ImageMapType({
                getTileUrl: (coord, zoom) => {
                    var n = Math.PI-2*Math.PI*coord.y/Math.pow(2,zoom);
                    var lat1 = (180/Math.PI*Math.atan(0.5*(Math.exp(n)-Math.exp(-n))));
                    var lng1 = coord.x / Math.pow(2.0, zoom) * 360.0 - 180;
                    
                    var n2 = Math.PI-2*Math.PI*(coord.y+1)/Math.pow(2,zoom);
                    var lat2 = (180/Math.PI*Math.atan(0.5*(Math.exp(n2)-Math.exp(-n2))));
                    var lng2 = (coord.x +1)  / Math.pow(2.0, zoom) * 360.0 - 180;

                    if(lat1<droneLayer.bbox.southWest.lat  - 10 || lat1> droneLayer.bbox.northEast.lat  + 10 ) return null
                    if(lat2<droneLayer.bbox.southWest.lat  - 10 || lat2> droneLayer.bbox.northEast.lat  + 10 ) return null
                    if(lng1<droneLayer.bbox.southWest.lng - 10  || lng1> droneLayer.bbox.northEast.lng + 10 ) return null
                    if(lng2<droneLayer.bbox.southWest.lng - 10  || lng2> droneLayer.bbox.northEast.lng + 10 ) return null
    
                    var minX = lng1
                    var maxX = lng2
                    if(lng1>lng2){
                        minX = lng2
                        maxX = lng1
                    }
                    var minY = lat1
                    var maxY = lat2
                    if(lat1>lat2){
                        minY = lat2
                        maxY = lat1
                    }
                    var url = ''
                    if ( droneLayer.tmsUrl !== '' ){
                        var ymax = 1 << zoom;
                        var y = ymax - coord.y -1;
                        url = droneLayer.tmsUrl + zoom + '/' + coord.x + '/' + y + '.png'
                        return url
                    }
                    url = droneLayer.mapServiceUrl + `&bbox=${minX},${minY},${maxX},${maxY}`;
                    return url;
                },
                tileSize: new window.google.maps.Size(256, 256),
                name: droneLayer.uid
                
            });
            window.mapRef.overlayMapTypes.push(this.imageMapType);
        }
    }

    render() {
        this.redraw();
        return null;
    }

}

export default MapsDroneLayer;


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsDroneLayer.js